import { Action} from "redux";
import api from "src/spintr/SpintrApi";
import { BLOG_POST_CREATED, BLOG_POST_UPDATED, CLEAR_TEASERBOXES, FETCH_TEASERBOXES } from './action-types'

export const fetchTeaserBoxes = () : Action => ({
    // @ts-ignore
    payload: api.get('/api/teaserbox/active'),
    type: FETCH_TEASERBOXES
});

export const clearTeaserBoxes = () : Action => ({
    type: CLEAR_TEASERBOXES
});

export const onBlogPostUpdated = (item: Spintr.IInformationFeedItem) => ({
    meta: { item },
    type: BLOG_POST_UPDATED
});

export const onBlogPostCreated = (item: Spintr.IInformationFeedItem) => ({
    meta: { item },
    type: BLOG_POST_CREATED
});
